import Select from './Select';
import SelectNode from './SelectNode';

export { SHOW_ALL, SHOW_CHILD, SHOW_PARENT } from './strategies';
export var TreeNode = SelectNode;

export default Select;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-tree-select@2.2.6@rc-tree-select/es/index.js
// module id = 834
// module chunks = 0